import { FC } from 'react';

import { SignatureStatus } from '../../enums/signature-status.const';
import { MultiSelectFilter, MultiSelectFilterOption } from './multi-select-filter';

export type MySignaturesFilterValue = 'expired' | 'signed' | 'to-sign';

const MY_SIGNATURES_FILTER_OPTIONS: MultiSelectFilterOption<MySignaturesFilterValue>[] = [
  { value: 'to-sign', labelKey: 'SIGNATURE_STATUS_SIGNATURE_PENDING' },
  { value: 'expired', labelKey: 'EXPIRED' },
  { value: 'signed', labelKey: 'SIGNED' },
];

export type MySignaturesFilterParams = {
  mySignatorySigned?: boolean;
  statuses?: SignatureStatus[];
};

export const mySignaturesFilterToParams = (
  value: MySignaturesFilterValue[],
): MySignaturesFilterParams => {
  if (value.length === 0) return {};

  const hasToSign = value.includes('to-sign');
  const hasExpired = value.includes('expired');
  const hasSigned = value.includes('signed');

  const statuses: SignatureStatus[] = [];
  if (hasToSign) {
    statuses.push(SignatureStatus.SIGNATURE_PENDING, SignatureStatus.PARTIALLY_SIGNED);
  }
  if (hasExpired) {
    statuses.push(SignatureStatus.DOCUMENT_EXPIRED);
  }
  if (hasSigned) {
    statuses.push(SignatureStatus.FULLY_SIGNED, SignatureStatus.PARTIALLY_SIGNED);
  }

  const uniqueStatuses = Array.from(new Set(statuses));

  let mySignatorySigned: boolean | undefined;
  if (hasToSign && !hasSigned) {
    mySignatorySigned = false;
  } else if (hasSigned && !hasToSign) {
    mySignatorySigned = true;
  }

  return {
    ...(uniqueStatuses.length > 0 ? { statuses: uniqueStatuses } : {}),
    ...(mySignatorySigned !== undefined ? { mySignatorySigned } : {}),
  };
};

type MySignaturesStatusFilterProps = {
  disabled?: boolean;
  onChange: (value: MySignaturesFilterValue[]) => void;
  value: MySignaturesFilterValue[];
};

export const MySignaturesStatusFilter: FC<MySignaturesStatusFilterProps> = ({
  disabled,
  onChange,
  value,
}) => (
  <MultiSelectFilter
    allOptionLabelKey="FILTER_ALL_STATUSES"
    disabled={disabled}
    onChange={onChange}
    options={MY_SIGNATURES_FILTER_OPTIONS}
    placeholderKey="FILTER_ALL_STATUSES"
    value={value}
  />
);
